import {
  EVENT
} from '../../../common/events/listEvents';

export default class PopUpModalAction {

  /**
   * display popup with yes/no action
   * @param {*} text 
   * @param {*} callback 
   */
  static openPopUpModal(text, callback) {
    window.popUpModalComp = {};
    window.popUpModalComp.message = text;
    window.popUpModalComp.yesAction = callback;
    window.popUpModalComp.showNoAction = true;
    window.fireEvent(EVENT.OPEN_POPUP_MODAL);
  }

   /**
   * display popup with yes/no action
   * @param {*} text 
   * @param {*} yesCallback 
   * @param {*} cancelCallback 
   */
  static openPopUpModalWithCancelCallback(text, yesCallback, cancelCallback) {
    window.popUpModalComp = {};
    window.popUpModalComp.message = text;
    window.popUpModalComp.yesAction = yesCallback;
    window.popUpModalComp.noAction = cancelCallback;
    window.popUpModalComp.showNoAction = true;
    window.fireEvent(EVENT.OPEN_POPUP_WITH_CANCEL_MODAL);
  }

  /**
   * display the popup with only yes action
   * @param {*} text 
   * @param {*} callback 
   */
  static openYesPopUpModal(text, callback) {
    window.popUpModalComp = {};
    window.popUpModalComp.message = text;
    window.popUpModalComp.yesAction = callback;
    window.popUpModalComp.showNoAction = false;
    window.fireEvent(EVENT.OPEN_POPUP_MODAL);
  }

  static closePopUpModal() {
    window.fireEvent(EVENT.CLOSE_POPUP_MODAL);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/PopUpModalComponent/PopUpModalAction.js